import { useRef } from "react";
import { IPopup } from "../components/Popup"; // Adjust the path as needed

export const usePopup = () => {
  const popup = useRef<IPopup | null>(null);

  // Function to open the popupRef
  const openPopup = () => {
    popup.current?.open();
  };

  // Function to close the popupRef
  const closePopup = () => {
    popup.current?.close();
  };

  return {
    popupRef: popup,
    open: openPopup,
    close: closePopup,
  };
};
